<template>
  <v-toolbar flat>
    <v-toolbar-title>
      {{ title }}
      <span></span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-2"
            fab
            small
            color="accent"
            router
            to="/gateways"
            v-on="on"
          >
            <v-icon dark>mdi-access-point</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("gateway.toolbar") }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-2"
            fab
            small
            color="primary"
            router
            to="/gateways/create"
            v-on="on"
            v-if="allowed(null, Roles.AdminOrCompanyAdmin)"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("common.create") }}</span>
      </v-tooltip>
    </div>
  </v-toolbar>
</template>

<script>
import { Roles } from "@/_helpers/Role";
export default {
  name: "GatewayToolbar",
  props: ["title"],
  computed: {
    Roles() {
      return Roles;
    },
  },
};
</script>
